import React from "react";
import PropTypes from "prop-types";
import MenuItem from "@material-ui/core/MenuItem";
import Link from "components/link";

const MenuElement = ({ url, children, onClick }) => {
  const handleOnClick = event => {
    event.preventDefault();
    if (onClick) {
      onClick();
    }
  };

  return (
    <MenuItem onClick={handleOnClick}>
      {onClick ? (
        <div>{children}</div>
      ) : (
        <Link href={url}>
          <div>{children}</div>
        </Link>
      )}
    </MenuItem>
  );
};

MenuElement.propTypes = {
  /**
   * Url del elemento de menú
   */
  url: PropTypes.string,
  /**
   * Acción a realizar en el onClick, en vez de utilizar una url
   */
  onClick: PropTypes.func,
};

export default MenuElement;
